import BrandIntro from "./components/BrandIntro";
import Reputation from "./components/Reputation";
import ContactSection from "./components/ContactSection";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SchemaOrg from "@/components/feature/SchemaOrg";

export default function AboutPage() {
  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: "51吃瓜",
          url: "https://51chigua.com",
          description:
            "51吃瓜网站是国内领先的娱乐八卦内容聚合平台，聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "400-888-5151",
            contactType: "customer service",
            availableLanguage: ["Chinese"],
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "关于51吃瓜 - 品牌介绍与联系我们",
          description:
            "了解51吃瓜网站的品牌故事、用户口碑和联系方式。国内领先的娱乐八卦内容聚合平台。",
          url: "https://51chigua.com/about",
          isPartOf: {
            "@type": "WebSite",
            name: "51吃瓜",
            url: "https://51chigua.com",
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              "@type": "Question",
              name: "51吃瓜网站提供哪些内容？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "51吃瓜网站聚焦每日大赛、台北娜娜、莫里秀、玩偶姐姐等热门系列，提供最新合集与高清视频资源，涵盖娱乐八卦、视频合集、黑料吃瓜等多个特色栏目。",
              },
            },
            {
              "@type": "Question",
              name: "如何联系51吃瓜客服？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "您可以通过电子邮箱contact@51chigua.com、客服热线400-888-5151，或在本站关于我们页面填写联系表单，我们会在24小时内回复。",
              },
            },
            {
              "@type": "Question",
              name: "51吃瓜的内容更新频率如何？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "51吃瓜编辑团队每日持续更新内容，确保用户第一时间获取最新八卦和视频资源。各栏目均有固定更新计划，保证内容的时效性。",
              },
            },
          ],
        }}
      />

      <main className="min-h-screen pt-16">
        <div className="bg-background-50 border-b border-background-200/60">
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-10">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mt-4">
              关于51吃瓜
            </h1>
            <p className="text-foreground-600 text-sm md:text-base mt-2">
              国内领先的娱乐八卦内容聚合平台
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <BrandIntro />
          <div className="border-t border-background-200/60"></div>
          <Reputation />
          <div className="border-t border-background-200/60"></div>
          <ContactSection />
        </div>
      </main>
    </>
  );
}